export default function IosColorWandOutline() {
  return (
    <div
      className="ion-icon-ios-color-wand-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M192.011,149.661l-34.043,34.041l256.097,256.096L448,405.757L192.011,149.661z M212.596,215.702l11.415-11.414
		l201.468,201.469l-11.414,11.414L212.596,215.702z"/>
	<rect x="184" y="64" width="16" height="40"/>
	<rect x="184" y="268" width="16" height="40"/>
	<rect x="280" y="176" width="40" height="16"/>
	<rect x="64" y="176" width="40" height="16"/>
	<rect x="111.875" y="94.077" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 285.3039 109.9734)" width="16" height="40"/>
	<rect x="111.877" y="238.327" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 21.9762 525.7571)" width="15.998" height="40"/>
	<rect x="256.126" y="94.077" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 370.226 381.506)" width="16" height="39.999"/>
</g>
</svg>
`,
      }}
    />
  )
}
